<p-dialog
  [modal]="true"
  [(visible)]="visible"
  (onHide)="onHide()"
  [style]="{ width: '25rem' }"
>
  <div class="flex justify-center items-center">
    <div
      class="size-28 border-[15px] border-[#f5f5f5] rounded-full bg-[#d7d7d7] flex items-center justify-center"
    >
      <i class="fa-solid fa-trash text-xl"></i>
    </div>
  </div>
<div class=" text-center my-8">
      <span class="text-center font-bold block mb-2">{{ message }}</span>
  <span class=" text-center text-[#A6252A] ">
    {{ paragraph }}
  </span>
</div>

  <div class="flex justify-between gap-2">
    <button
      type="button"
      (click)="visible = false; visibleChange.emit(false)"
      class="bg-[#FAFAFA] rounded-2xl px-4 py-2 text-black"
    >
      {{cancel}}
    </button>
    <button
      type="button"
      (click)="onClick()"
      class="bg-[#A6252A] rounded-2xl px-10 py-2 text-white"
    >
      {{delete}}
    </button>
  </div>
</p-dialog>
